module.exports = __webpack_public_path__ + "static/media/homepage-blob.af16f80a.svg";